import { EvaluationDetail } from 'lib/api/decisionEngine/types';

export type EvaluationDetailExtended = EvaluationDetail & { state?: string };

export type NodeResult = {
  status?: 'WAITING' | 'COMPLETED' | 'FAILED';
  result: boolean | null;
  nodeName: string;
  resultText: string | null;
  statusNode: { name: string; description?: string; severity?: number } | null;
  nodeIdDecision: number | null;
  subDecisionEngineRevisionStory: NodeResult[] | null;
};

export const isNodeWaiting = (node: NodeResult): boolean =>
  node.status === 'WAITING';

export const isNodeFailed = (node: NodeResult): boolean =>
  node.status === 'FAILED';
